import { useContext } from "react";
import { AppHeaderContext } from "./AppHeaderContext";
import { AppHeaderContextType } from "./AppHeaderContextTypes";



export function useAppHeaderContext() {
    const context = useContext<AppHeaderContextType | undefined>(AppHeaderContext);
    if (!context) {
        throw new Error("useAppHeaderContext must be used within a AppHeaderContextProvider");
    }
    return context;
}
